import { useEffect, useState } from 'react';

import { dayjst } from '@/lib/dayjst';
import { BetDataList } from '@/modelTypes';
import { betDataLocalStorage, RaceType } from '@/storages/race/betData';

const useBetPanel = (): [
  BetDataList,
  React.Dispatch<React.SetStateAction<BetDataList>>,
] => {
  const [betPanelData, setBetPanelData] = useState<BetDataList>(
    {} as BetDataList,
  );
  const storage = betDataLocalStorage<BetDataList>(RaceType.Singlerace);

  useEffect(() => {
    const storageBetDataList = storage.get();

    // 投票期限の過ぎたレースデータは削除する
    if (storageBetDataList) {
      Object.entries(storageBetDataList).forEach(([id, data]) => {
        if (Object.values(data).some(d => dayjst().isAfter(d.orderDeadline))) {
          delete storageBetDataList[id];
        }
      });
    }

    setBetPanelData(storageBetDataList || ({} as BetDataList));
  }, []);

  useEffect(() => {
    storage.set(betPanelData);
  }, [betPanelData]);

  return [betPanelData, setBetPanelData];
};

export default useBetPanel;
